const matchesPath = (pathname: string, href?: string): href is string =>
	!!href?.startsWith('/') && (pathname === href || pathname.startsWith(`${href}/`));

/**
 * Whether a site link is the current page. A link also matches the pages
 * nested under it, unless a sibling link points closer to the current path:
 * on `/hat/my-hats` only "My HATs" is active, not "HAT Gallery" (`/hat`).
 */
export const isSiteLinkActive = ({
	pathname,
	href,
	siblingHrefs
}: {
	pathname: string;
	href: string | undefined;
	siblingHrefs: (string | undefined)[];
}) =>
	matchesPath(pathname, href) &&
	!siblingHrefs.some(
		(siblingHref) => matchesPath(pathname, siblingHref) && siblingHref.length > href.length
	);
